module.exports = __webpack_public_path__ + "img/logo.7dbfb797.png";